import React from "react";
import PropTypes from "prop-types";
import { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import FormTextField from "components/form/form-textfield";
import { CardWithDelete } from "components/card";

const AwsElasticIpsForm = ({ index, collectionName, element, onChange, onDelete, intl }) => (
  <CardWithDelete onDelete={onDelete}>
    <DataGridItem>
      <FormTextField
        type="text"
        id={`${collectionName}.${index}`}
        name={`${collectionName}.${index}`}
        value={element}
        onChange={onChange}
        label={intl.formatMessage({ id: "deployment.awsElasticIp" })}
      />
    </DataGridItem>
  </CardWithDelete>
);

AwsElasticIpsForm.propTypes = {
  /**
   * Índice del elemento en la colección
   */
  index: PropTypes.number,
  /**
   * Nombre de la colección
   */
  collectionName: PropTypes.string,
  /**
   * Función que se invoca al modificar algún valor
   */
  onChange: PropTypes.func,
  /**
   * Función que se invoca al eliminar el contacto del formulario
   */
  onDelete: PropTypes.func,
  /**
   * Objeto con los valores que se quieren representar
   */
  element: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

export default injectIntl(AwsElasticIpsForm);
